import React from 'react';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import RedeemIcon from '@mui/icons-material/Redeem';
import EmailIcon from '@mui/icons-material/Email';
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Link } from 'react-router-dom';


const HelpPage = () => {


    return (
        <div className="px-5 bg-white py-10 my-4 shadow-md">

            <div className="flex items-center mb-4">
                <Link to="/" style={{ textDecoration: 'none' }}>
                    <IconButton style={{ color: 'black', backgroundColor: 'white', border: '2px solid black' }}>
                        <ArrowBackIcon />
                    </IconButton>
                </Link>
                <h1 className="text-2xl font-bold ml-4">Help Page</h1>
            </div>
            <p>Quick guide on how to use our service:</p>

            <ul className="list-none pl-5">
                <li>
                    <h2 className="text-xl font-semibold mt-5 mb-1 flex items-center">
                        <ShoppingCartIcon className="mr-2" />
                        Get Coupons
                        <a href="https://splitdiscount.com" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                            <IconButton size="small" style={{ color: 'black', marginLeft: '10px', border: '2px solid black', borderRadius:"10%"}}>
                                Buy now
                            </IconButton>
                        </a>
                    </h2>
                    <p>Visit our web shop, complete your purchase with same e-mail.</p>
                </li>
                <li>
                    <h2 className="text-xl font-semibold mt-3 mb-1 flex items-center">
                        <AccountCircleIcon className="mr-2" />Access Coupons
                    </h2>
                    <p>Log in to the app to view and manage your coupons.</p>
                </li>
                <li>
                    <h2 className="text-xl font-semibold mt-3 mb-1 flex items-center">
                        <RedeemIcon className="mr-2" />Use Coupons
                    </h2>
                    <p>Show the coupon code in the app to the store staff for validation / use.</p>
                </li>
            </ul>

            <div className="mt-10">
                <h3 className="text-lg font-semibold">Contact Us</h3>
                <div className="flex items-center mt-2">
                    <EmailIcon className="mr-2" /> <span>info@splitdiscount.com</span>
                </div>
            </div>
        </div>
    );
};

export default HelpPage;
